import React from "react";
import { Mail, Phone, Headset } from "lucide-react";
import { Modal } from "./ui/Modal";
import { Avatar, EmptyState } from "./ui/Layout";
import { usePortal } from "./PortalContext";

/** Ajutor & PM dedicat — persoanele de contact Brisk pentru fiecare proiect al clientului. */
export default function PmContactModal({ open, onOpenChange }) {
  const { overview } = usePortal();
  const rows = [];
  const seen = new Set();
  (overview?.projects || []).forEach((p) => {
    const pm = p.pm;
    if (!pm?.name) return;
    const key = pm.email || pm.name;
    if (seen.has(key)) { rows.find((r) => r.key === key).projects.push(p.name); return; }
    seen.add(key); rows.push({ key, pm, projects: [p.name] });
  });

  return (
    <Modal open={open} onOpenChange={onOpenChange} title="Ajutor & PM dedicat" testid="pm-contact-modal"
      description="Pentru orice întrebare legată de proiect, contactează direct Project Managerul responsabil.">
      {rows.length === 0 ? (
        <EmptyState icon={Headset} compact title="Project Managerul nu a fost încă publicat"
          description="Scrie-ne la suport@briskgrp.com și te redirecționăm către persoana potrivită." />
      ) : (
        <ul className="divide-y divide-cp-border -mx-2">
          {rows.map(({ key, pm, projects }) => (
            <li key={key} className="flex items-start gap-3 px-2 py-3.5" data-testid="pm-contact-row">
              <Avatar name={pm.name} src={pm.avatar_url ? `${process.env.REACT_APP_BACKEND_URL}${pm.avatar_url}` : undefined} />
              <div className="flex-1 min-w-0">
                <div className="text-[14px] font-semibold text-cp-text">{pm.name}</div>
                <div className="cp-meta">{pm.job_title || "Project Manager"} · {projects.join(", ")}</div>
                <div className="mt-2 flex flex-wrap gap-2">
                  {pm.email && <a href={`mailto:${pm.email}`} className="inline-flex items-center gap-1.5 h-8 px-3 rounded-[var(--cp-radius)] border border-cp-border-strong text-[13px] font-medium text-cp-text hover:bg-cp-surface-hover"><Mail className="h-3.5 w-3.5" /> Trimite email</a>}
                  {pm.phone && <a href={`tel:${pm.phone.replace(/\s+/g, "")}`} className="inline-flex items-center gap-1.5 h-8 px-3 rounded-[var(--cp-radius)] border border-cp-border-strong text-[13px] font-medium text-cp-text hover:bg-cp-surface-hover"><Phone className="h-3.5 w-3.5" /> {pm.phone}</a>}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
      <p className="cp-meta mt-4 pb-2">Suport general: <a href="mailto:suport@briskgrp.com" className="text-cp-accent hover:underline">suport@briskgrp.com</a></p>
    </Modal>
  );
}
